<template>
  <span>
    {{ t == 1 ? "【单选】" : t == 2 ? "【多选】" : "【不定项】" }}
    <span v-if="$attrs.topicScore">（分值：{{ score }}分）</span>
  </span>
</template>

<script>
export default {
  name: "TopicType",
  props: {
    t: {
      type: Number,
      default: 1
    }
  },
  computed: {
    // 考试分数，单独接口，根据类型获取
    score() {
      let score = 1;
      this.$attrs.topicScore.forEach(item => {
        if (item.optionFlag === this.t) {
          score = item.score;
        }
      });
      return score;
    }
  }
};
</script>
